function normalizeItemValue(value) {
  return String(value || "").trim().toLocaleLowerCase();
}

export function findExactMasterItem(items, value) {
  const normalizedValue = normalizeItemValue(value);
  if (!normalizedValue) return null;

  return (
    (Array.isArray(items) ? items : []).find(
      (item) =>
        normalizeItemValue(item?.name) === normalizedValue ||
        normalizeItemValue(item?.code) === normalizedValue
    ) || null
  );
}

export function createQuickItemCode(name, itemType, items = []) {
  const typePrefix = String(itemType || "").toLocaleLowerCase() === "purchase" ? "PUR" : "SAL";
  const namePart = String(name || "")
    .trim()
    .toLocaleUpperCase()
    .replace(/[^A-Z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 12) || "ITEM";
  const usedCodes = new Set(
    (Array.isArray(items) ? items : []).map((item) => normalizeItemValue(item?.code)).filter(Boolean)
  );
  const baseCode = `${typePrefix}-${namePart}`;
  let code = baseCode;
  let suffix = 2;
  while (usedCodes.has(normalizeItemValue(code))) {
    code = `${baseCode}-${suffix}`;
    suffix += 1;
  }
  return code;
}

export function buildQuickItemPayload({ name, itemType, items = [] }) {
  const normalizedName = String(name || "").trim();
  const normalizedType = String(itemType || "").toLocaleLowerCase() === "purchase" ? "purchase" : "billing";
  return {
    code: createQuickItemCode(normalizedName, normalizedType, items),
    name: normalizedName,
    itemGroup: "",
    purchasePrice: 0,
    sellingPrice: 0,
    itemType: normalizedType,
  };
}

export async function confirmAndCreateQuickItem({
  name,
  itemType,
  items,
  confirmCreate,
  createItem,
}) {
  const normalizedName = String(name || "").trim();
  if (!normalizedName) return { status: "empty", item: null };

  const existingItem = findExactMasterItem(items, normalizedName);
  if (existingItem) return { status: "existing", item: existingItem };

  const confirmed = confirmCreate(
    `"${normalizedName}" is a non-existing item. Are you sure you want to add it to Item Master?`
  );
  if (!confirmed) return { status: "cancelled", item: null };

  const payload = buildQuickItemPayload({ name: normalizedName, itemType, items });
  const savedItem = await createItem(payload);
  return { status: "created", item: savedItem || payload, payload };
}
